@if (column?.detailsOnly) {
<div class="d-flex align-items-center gap-1">
  <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
    [tooltip]="'Voir les détails de la mission'"></svg-icon>
</div>
} @else {
<div class="d-flex align-items-center gap-1">
  @if (data.isfragmentable || data.missionStatus == 'FRAGMENT') {

  @if (data.missionStatus == MissionStatusEnum.DRAFT) {
  <div class="d-flex align-items-center gap-1">
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
    <svg-icon src="assets/icons/edit-action.svg" (click)="goTo()" class="cursor-pointer"></svg-icon>
    <svg-icon src="assets/icons/trash-red.svg" (click)="deleteMission()" class="cursor-pointer"></svg-icon>
  </div>
  } @else {
  @if (!expired && data.missionStatus != 'FRAGMENT') {
  <svg-icon src="assets/icons/statistics.svg" class="action-icon cursor-pointer" (click)="navigateToFragmentedMission()"
    [tooltip]="'Gestion de la segmentation'"></svg-icon>
  }

  <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
    [tooltip]="'Voir les détails de la mission'"></svg-icon>
  }

  } @else {
  @if (expired) {
  <div class="">
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
    @if (totallyValidated) {
    <svg-icon src="assets/icons/candidature-white.svg" class="action-icon" (click)="openMissionCandidacies()"
      [tooltip]="'Voir et évaluer les missions terminées'"></svg-icon>
    } @else {
    @if (candidatList && candidatList.length > 0 && statusCandidateAccepted) {
    @switch (statusCandidateAccepted) {
    @case (CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION) {
    <svg-icon src="assets/icons/notif.svg" [tooltip]="'Envoyer un rappel à l\'établissement pour valider la mission'"
      (click)="sendReminder()" class="action-icon cursor-pointer"></svg-icon>
    }
    @case (CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT) {
    <svg-icon src="assets/icons/check.svg" [tooltip]="'Valider le paiement'"
      class="action-icon cursor-pointer"></svg-icon>
    }
    @case (CandidatStatusOnMission.PAYMENT_DONE) {
    <svg-icon src="assets/icons/visible.svg" [tooltip]="'Voir les détails du paiement'"
      class="action-icon cursor-pointer"></svg-icon>
    }
    @case (CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT) {
    <svg-icon src="assets/icons/visible.svg" (click)="getMotifRefus()"
      [tooltip]="'Voir les raisons du refus de validation'" class="action-icon cursor-pointer"></svg-icon>

    }
    @default {
    }
    }
    }
    }

  </div>
  } @else {

  @switch (data.missionStatus) {
  @case (MissionStatusEnum.PENDING) {
  <div class="d-flex align-items-center gap-1">
    @if (isTotallyAffected()) {
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
    <svg-icon src="assets/icons/candidature-white.svg"
      [tooltip]="'Voir et gérer le ou les professionnel(s) de santé affecté(s) à cette mission'"
      (click)="openMissionCandidacies()" class="cursor-pointer action-icon"></svg-icon>
    <svg-icon src="assets/icons/edit-action.svg" class="cursor-pointer action-icon"
      [tooltip]="'Modifier / envoyer les contrats restants'" (click)="openContractPreview()"></svg-icon>
    } @else if (isContractPendingValidation()) {
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
    <svg-icon src="assets/icons/candidature-white.svg" class="action-icon"
      [tooltip]="'Voir les candidatures'" (click)="openMissionCandidacies()"></svg-icon>
    <svg-icon src="assets/icons/edit-action.svg" class="cursor-pointer action-icon"
      [tooltip]="'Modifier, valider et envoyer les contrats'" (click)="openContractPreview()"></svg-icon>
    } @else if (isAccepted()) {
    <svg-icon src="assets/icons/candidature-white.svg" class="action-icon" (click)="openMissionCandidacies()"
      [tooltip]="'Voir et gérer les candidatures'"></svg-icon>
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
    @if (canCancelMission()) {
    <svg-icon src="assets/icons/close.svg" [tooltip]="'Annuler cette offre de mission'" (click)="cancelPendingMission()"
      class="cursor-pointer"></svg-icon>
    }
    <svg-icon src="assets/icons/edit-action.svg" class="cursor-pointer action-icon"
      [tooltip]="'Modifier / envoyer les contrats restants'" (click)="openContractPreview()"></svg-icon>
    } @else {
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
    @if (canCancelMission()) {
    <svg-icon src="assets/icons/close.svg" [tooltip]="'Annuler cette offre de mission'" (click)="cancelPendingMission()"
      class="cursor-pointer"></svg-icon>
    }
    }

  </div>
  }
  @case (MissionStatusEnum.DRAFT) {
  <div class="d-flex align-items-center gap-1">
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
    <svg-icon src="assets/icons/edit-action.svg" (click)="goTo()" class="cursor-pointer"></svg-icon>
    <svg-icon src="assets/icons/trash-red.svg" (click)="deleteMission()" class="cursor-pointer"></svg-icon>
  </div>

  }
  @case (MissionStatusEnum.CANCELED) {
  <div class="d-flex align-items-center gap-1">
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
  </div>
  }
  @default {
  <div class="d-flex align-items-center gap-1">
    <svg-icon src="assets/icons/visible.svg" class="action-icon" (click)="openMissionDetails()"
      [tooltip]="'Voir les détails de la mission'"></svg-icon>
    <svg-icon src="assets/icons/candidature-white.svg"
      [tooltip]="'Voir et gérer le ou les professionnel(s) de santé affecté(s) à cette mission'"
      (click)="openMissionCandidacies()" class="cursor-pointer action-icon"></svg-icon>
  </div>
  }
  }
  }
  }
</div>
}

<ng-template #missionCandidaciesDialog>
  <app-mission-candidatures [candidatesApplied]="data.candidatesApplied" [missionId]="data.id" [mData]="data" [etbId]="etbId"
    [expired]="expired">
  </app-mission-candidatures>
</ng-template>

<ng-template #missionAllCandidaciesDialog>
  <app-mission-candidatures [availableCandidates]="availableCandidates" [missionId]="data.id" [expired]="expired"
    [mData]="data">
  </app-mission-candidatures>
</ng-template>

@if (loading) {
<div class="action-loader-overlay">
  <div class="action-loader-spinner"></div>
</div>
}